import { createFileRoute } from "@tanstack/react-router"
import { lazyImportRouteComponent } from "../../../../utils/lazyImportRouteComponent"
import { SelectedPerson } from "../../-components/selected-person-types"

type SearchParams = {
  personId: number
  phone?: string
  source?: SelectedPerson["selectionSource"]
}

export const Route = createFileRoute("/app/contacts/create-memo/")({
  component: lazyImportRouteComponent(
    () => import("./-components/create-memo-page"),
    "CreateMemoPage"
  ),
  validateSearch: (search: SearchParams) => search,
  beforeLoad: ({ search }) => {
    if (!search.personId) {
      throw new Error("personId is required")
    }
  },
})
